import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineExpandAltIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M9.79 12.79 4 18.59V17a1 1 0 1 0-2 0v4a.9998.9998 0 0 0 .08.38c.1015.2443.2956.4385.54.54A1.001 1.001 0 0 0 3 22h4a1.0002 1.0002 0 0 0 .7071-1.7071A1.0002 1.0002 0 0 0 7 20H5.41l5.8-5.79a1.0041 1.0041 0 1 0-1.42-1.42ZM21.92 2.62a1.0002 1.0002 0 0 0-.54-.54A.9998.9998 0 0 0 21 2h-4a1 1 0 1 0 0 2h1.59l-5.8 5.79a1.001 1.001 0 0 0-.2958.71.9997.9997 0 0 0 .2958.71.9997.9997 0 0 0 1.42 0L20 5.41V7a1.0002 1.0002 0 0 0 1.7071.7071A1.0002 1.0002 0 0 0 22 7V3a1.0011 1.0011 0 0 0-.08-.38Z"/>
  </SvgIcon>
}

export default LineExpandAltIcon
